import {
  MapContainer,
  TileLayer,
  Polygon,
  Marker,
  Popup,
  useMapEvents,
} from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import { useEffect, useState } from "react";

function calculateCenter(polygon) {
  const latitudes = polygon.map((point) => point[0]);
  const longitudes = polygon.map((point) => point[1]);

  const latSum = latitudes.reduce((a, b) => a + b, 0);
  const lonSum = longitudes.reduce((a, b) => a + b, 0);

  const latCenter = latSum / latitudes.length;
  const lonCenter = lonSum / longitudes.length;

  return [latCenter, lonCenter];
}

const farmBoundary = [
  [35.6892, 51.389],
  [35.6895, 51.3895],
  [35.6898, 51.389],
  [35.6895, 51.3885],
];

// Component for handling map clicks and updating marker position

function MapIran({ stepOne, setStepOne }) {
  const [markerPosition, setMarkerPosition] = useState(null);
  function AddMarkerOnClick({ setMarkerPosition }) {
    useMapEvents({
      click(e) {
        setMarkerPosition(e.latlng); // Set marker position to clicked location
        setStepOne({ ...stepOne, lat: e.latlng.lat, lng: e.latlng.lng });
        // setStepOne({ ...stepOne, lng: e.latlng.lng });
      },
    });
    return null;
  }

  // console.log(markerPosition);

  useEffect(() => {
    if (stepOne?.lat && stepOne?.lng) {
      setMarkerPosition({ lat: stepOne?.lat, lng: stepOne?.lng });
    }
  }, [stepOne]);

  return (
    <MapContainer
      center={[32.6892, 53.389]}
      zoom={5}
      style={{ height: "100%", width: "100%" }}
    >
      <TileLayer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
      />
      <Polygon
        positions={farmBoundary}
        color="blue"
        weight={2}
        opacity={0.7}
        fillColor="blue"
        fillOpacity={0.3}
      />
      {/* Static marker at the center of the polygon */}
      {/* <Marker
        position={calculateCenter(farmBoundary)}
        icon={L.icon({
          iconUrl: "/mapMarker.png",
          iconSize: [32, 32],
          iconAnchor: [16, 32],
          popupAnchor: [0, -32],
        })}
      >
        <Popup>محصول این زمین</Popup>
      </Marker> */}

      {/* Marker that moves based on click */}
      {markerPosition && (
        <Marker
          position={markerPosition}
          icon={L.icon({
            iconUrl: "/mapMarker.png",
            iconSize: [32, 32],
            iconAnchor: [16, 32],
            popupAnchor: [0, -32],
          })}
        ></Marker>
      )}

      {/* Component to handle map clicks */}
      <AddMarkerOnClick setMarkerPosition={setMarkerPosition} />
    </MapContainer>
  );
}

export default MapIran;
